import { UserSettingsContextDispatch, UserSettingsContextState } from './context';
import { useContext } from 'react';

export const useUserSettingsStateContext = () => {
    const context = useContext(UserSettingsContextState);

    if(!context) {
        throw Error('useUserSettingsStateContext must be used inside an AuthContextProvider')
    }
    
    return context
};

export const useUserSettingsDispatchContext = () => {
    const context = useContext(UserSettingsContextDispatch);

    if(!context) {
        throw Error('useUserSettingsDispatchContext must be used inside an AuthContextProvider')
    }
    
    return context
};